
<div class="videowrapper">
  <div v-if="hasText" class="media-video-text-block h-100 w-100">
    <div class="w-100 h-100 div_general">
      <b-row class="w-100 h-100 d-flex position-relative offre_special_container">
        <b-col cols="8" class="h-25 mt-2">
          <div v-if="content.petiteNote" class="boite_petite_note">
            <span class="petite_note graphik_bold" v-html="content.petiteNote"> </span>
          </div>
        </b-col>
        <b-col
          class="d-flex flex-column align-items-center align-items-md-start py-1 py-md-0 justify-content-center position-static col-12 col-md-4 barreDessousMobile mobile_text_center"
          :style="styleObject"
        >
          <div>
            <div
              v-if="content.surTitre"
              class="offre_surtitre graphik_bold"
              v-html="content.surTitre"
            ></div>
            <h3 class="titre graphik_bold" v-html="content.titre"></h3>
          </div>
          <div class="sousTitre" v-html="content.sousTitre"></div>
          <b-link
            v-if="content.lien"
            :id="content['@id']"
            v-bind="jel_getLienBinding(content.lien)"
            :ga-img-name="imageName"
            class="stretched-link offre-speciale"
            :data-tag="`${jel_getNomRouteCourante()} - ${content.titre.replace(
              /&nbsp;/g,
              ' '
            )} - ${content.sousTitre} - ${content.dataTag}`"
          >
            <button
              class="videobtn btn graphik_bold"
              :style="[
                { 'border-color': content.borderColorBtn },
                { 'background-color': content.colorBtn },
              ]"
            >
              {{ content.texteBouton }}
            </button>
          </b-link>
        </b-col>
      </b-row>
    </div>
  </div>

  <div class="yt-ambiance-video" :style="{ 'background-image': 'url(' + content.bgImage + ')' }">
    <div class="player-container">
      <div class="content-inner youtube-container embed-responsive embed-responsive-16by9">
        <iframe
          class="iframe_video"
          :width="largeur"
          height="380"
          :data-src="lien"
          type="text/html"
          frameborder="0"
          allowfullscreen
          title="iFrame MediaVideo"
        >
        </iframe>

        <!-- Message & "I accept" button -->

        <div class="video-consent-overlay">
          <div class="scrollable-section">
            <div class="logo">
              <svg-icon icon-name="youtube"></svg-icon>
            </div>
            <div class="video-consent-overlay-text">
              <p>
                {{ $t('youtubeVideoConsent.texte') }}
              </p>
            </div>
          </div>
          <button class="video-consent-overlay-accept-button">
            {{ $t('youtubeVideoConsent.texteBoutonAccept') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
